// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: '智能视频图像检测系统',
		category: '深度学习',
		img: require('@/assets/images/ducha.jpg'),
	},
	{
		id: 2,
		title: '智能AI赋能平台',
		category: '大模型',
		img: require('@/assets/images/zhinengAI.jpg'),
	},
	{
		id: 3,
		title: '单兵突刺训练考核系统',
		category: '深度学习',
		img: require('@/assets/images/tuci.jpg'),
	},
	{
		id: 4,
		title: '香烟检测',
		category: '深度学习',
		img: require('@/assets/images/xianyan.jpg'),
	},
	{
		id: 5,
		title: '大理石对纹系统',
		category: '传统图像处理',
		img: require('@/assets/images/dalishi.jpg'),
	},
	{
		id: 6,
		title: '火药用量检测',
		category: '传统图像处理',
		img: require('@/assets/images/huoyao.jpg'),
	},
	{
		id: 7,
		title: '焊缝检测',
		category: '深度学习',
		img: require('@/assets/images/hanfeng.jpg'),
	},
	{
		id: 8,
		title: '基于随机森林的执法风险评估系统',
		category: '其他',
		img: require('@/assets/images/suiji.jpg'),
	},
];

export default projects;
